import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=da33842a&scoped=true"
import script from "./Vision.vue?vue&type=script&lang=js"
export * from "./Vision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da33842a",
  null
  
)

export default component.exports